import React, { useEffect, useState } from 'react';
import { attractionsApi } from '../services/api';
import ImageUploader from '../components/ImageUploader';

const EMPTY = {
  name_it: '', name_en: '', name_de: '',
  description_it: '', description_en: '', description_de: '',
  city: '', address: '', latitude: '', longitude: '',
  category: 'monumento', image_url: '',
  admission_price: '0', website: '',
  opening_hours: '',
};

const CATEGORIES = [
  { value: 'monumento',  label: '🏛️ Monumento' },
  { value: 'museo',      label: '🖼️ Museo' },
  { value: 'parco',      label: '🌳 Parco' },
  { value: 'chiesa',     label: '⛪ Chiesa' },
  { value: 'piazza',     label: '🏟️ Piazza' },
  { value: 'panorama',   label: '🌅 Panorama' },
  { value: 'mercato',    label: '🛍️ Mercato' },
  { value: 'altro',      label: '📍 Altro' },
];

export default function AttractionsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [filterCity, setFilterCity] = useState('');

  const load = () =>
    attractionsApi.list(filterCity ? { city: filterCity } : {})
      .then(r => setItems(r.data))
      .catch(() => {});

  useEffect(() => { load(); }, [filterCity]);

  const save = async (e) => {
    e.preventDefault();
    try {
      const data = {
        ...form,
        latitude:  form.latitude  ? parseFloat(form.latitude)  : null,
        longitude: form.longitude ? parseFloat(form.longitude) : null,
        opening_hours: form.opening_hours
          ? { info: form.opening_hours }
          : null,
      };
      if (editing) {
        await attractionsApi.update(editing, data);
      } else {
        await attractionsApi.create(data);
      }
      setShowForm(false);
      setEditing(null);
      setForm(EMPTY);
      load();
    } catch (err) {
      alert('Erro: ' + err.message);
    }
  };

  const del = async (id) => {
    if (!window.confirm('Excluir atração?')) return;
    await attractionsApi.delete(id);
    load();
  };

  const startEdit = (item) => {
    setForm({
      ...EMPTY,
      ...item,
      opening_hours: item.opening_hours?.info || '',
    });
    setEditing(item.id);
    setShowForm(true);
  };

  const f = (key) => (e) => setForm(p => ({ ...p, [key]: e.target.value }));

  const cities = [...new Set(items.map(i => i.city).filter(Boolean))];

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h2 style={styles.title}>🏛️ Atrações Turísticas</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <select style={styles.select} value={filterCity} onChange={e => setFilterCity(e.target.value)}>
            <option value="">Todas as cidades</option>
            {cities.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
          <button style={styles.btnPrimary} onClick={() => { setForm(EMPTY); setEditing(null); setShowForm(true); }}>
            + Nova Atração
          </button>
        </div>
      </div>

      {showForm && (
        <form onSubmit={save} style={styles.formCard}>
          <h3 style={styles.formTitle}>{editing ? '✏️ Editar Atração' : '➕ Nova Atração'}</h3>

          {/* Imagem */}
          <ImageUploader
            label="Imagem da atração"
            value={form.image_url}
            onChange={url => setForm(p => ({ ...p, image_url: url }))}
          />

          <div style={styles.grid2}>
            {/* Nomes */}
            <label style={styles.label}>Nome 🇮🇹 Italiano *
              <input style={styles.input} value={form.name_it} onChange={f('name_it')} required />
            </label>
            <label style={styles.label}>Nome 🇬🇧 Inglês
              <input style={styles.input} value={form.name_en} onChange={f('name_en')} />
            </label>
            <label style={styles.label}>Nome 🇩🇪 Alemão
              <input style={styles.input} value={form.name_de} onChange={f('name_de')} />
            </label>

            {/* Categoria */}
            <label style={styles.label}>Categoria
              <select style={styles.input} value={form.category} onChange={f('category')}>
                {CATEGORIES.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
              </select>
            </label>

            {/* Localização */}
            <label style={styles.label}>Cidade *
              <input style={styles.input} value={form.city} onChange={f('city')} required placeholder="ex: Roma" />
            </label>
            <label style={styles.label}>Endereço
              <input style={styles.input} value={form.address} onChange={f('address')} placeholder="ex: Piazza del Colosseo 1" />
            </label>
            <label style={styles.label}>Latitude
              <input style={styles.input} type="number" step="any" value={form.latitude} onChange={f('latitude')} placeholder="ex: 41.8902" />
            </label>
            <label style={styles.label}>Longitude
              <input style={styles.input} type="number" step="any" value={form.longitude} onChange={f('longitude')} placeholder="ex: 12.4922" />
            </label>

            {/* Detalhes */}
            <label style={styles.label}>Preço de entrada (€)
              <input style={styles.input} value={form.admission_price} onChange={f('admission_price')} placeholder="0 = Gratuito" />
            </label>
            <label style={styles.label}>Website
              <input style={styles.input} value={form.website} onChange={f('website')} placeholder="https://..." />
            </label>
            <label style={styles.label}>Horário de funcionamento
              <input style={styles.input} value={form.opening_hours} onChange={f('opening_hours')} placeholder="ex: Seg-Dom 09:00–19:00" />
            </label>
          </div>

          {/* Descrições */}
          <label style={styles.label}>Descrição 🇮🇹 Italiano
            <textarea style={styles.textarea} value={form.description_it} onChange={f('description_it')} placeholder="Descrizione in italiano..." />
          </label>
          <label style={styles.label}>Descrição 🇬🇧 Inglês
            <textarea style={styles.textarea} value={form.description_en} onChange={f('description_en')} placeholder="Description in English..." />
          </label>
          <label style={styles.label}>Descrição 🇩🇪 Alemão
            <textarea style={styles.textarea} value={form.description_de} onChange={f('description_de')} placeholder="Beschreibung auf Deutsch..." />
          </label>

          <div style={{ display: 'flex', gap: 10, marginTop: 16 }}>
            <button style={styles.btnPrimary} type="submit">💾 Salvar</button>
            <button style={styles.btnSecondary} type="button" onClick={() => setShowForm(false)}>Cancelar</button>
          </div>
        </form>
      )}

      {/* Lista de atrações */}
      <div style={styles.grid}>
        {items.map(item => (
          <div key={item.id} style={styles.card}>
            {item.image_url && (
              <img src={item.image_url} alt={item.name_it} style={styles.cardImg} />
            )}
            {!item.image_url && (
              <div style={styles.cardImgPlaceholder}>
                <span style={{ fontSize: 40 }}>
                  {CATEGORIES.find(c => c.value === item.category)?.label.split(' ')[0] || '📍'}
                </span>
              </div>
            )}
            <div style={styles.cardBody}>
              <div style={styles.cardHeader}>
                <span style={styles.categoryBadge}>
                  {CATEGORIES.find(c => c.value === item.category)?.label || item.category}
                </span>
                {item.admission_price === '0' || item.admission_price === 0
                  ? <span style={styles.freeBadge}>🎟 Gratuito</span>
                  : <span style={styles.priceBadge}>🎟 €{item.admission_price}</span>
                }
              </div>
              <h3 style={styles.cardTitle}>{item.name_it || item.name_en}</h3>
              <p style={styles.cardCity}>📍 {item.city}{item.address ? ` — ${item.address}` : ''}</p>
              {item.opening_hours?.info && (
                <p style={styles.cardHours}>🕐 {item.opening_hours.info}</p>
              )}
              {item.description_it && (
                <p style={styles.cardDesc}>{item.description_it.slice(0, 100)}{item.description_it.length > 100 ? '...' : ''}</p>
              )}
              <div style={styles.cardActions}>
                <button style={styles.btnSmall} onClick={() => startEdit(item)}>✏️ Editar</button>
                <button style={{ ...styles.btnSmall, color: '#E63946' }} onClick={() => del(item.id)}>🗑️ Excluir</button>
              </div>
            </div>
          </div>
        ))}

        {items.length === 0 && (
          <div style={styles.empty}>
            <span style={{ fontSize: 48 }}>🏛️</span>
            <p>Nenhuma atração cadastrada ainda.</p>
            <button style={styles.btnPrimary} onClick={() => { setForm(EMPTY); setEditing(null); setShowForm(true); }}>
              + Adicionar primeira atração
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: { padding: 24 },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 },
  title: { margin: 0, color: '#1D3557', fontSize: 22 },
  select: { padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd', fontSize: 14, color: '#333' },
  formCard: { background: '#fff', borderRadius: 14, padding: 24, marginBottom: 24, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
  formTitle: { margin: '0 0 20px', color: '#1D3557' },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 16 },
  label: { display: 'block', fontSize: 13, color: '#555', fontWeight: '600' },
  input: { display: 'block', width: '100%', padding: '9px 11px', borderRadius: 8, border: '1px solid #ddd', marginTop: 5, fontSize: 14, boxSizing: 'border-box', color: '#333' },
  textarea: { display: 'block', width: '100%', padding: '9px 11px', borderRadius: 8, border: '1px solid #ddd', marginTop: 5, fontSize: 14, minHeight: 80, resize: 'vertical', boxSizing: 'border-box', marginBottom: 12 },

  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 18 },
  card: { background: '#fff', borderRadius: 14, overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.07)' },
  cardImg: { width: '100%', height: 160, objectFit: 'cover', display: 'block' },
  cardImgPlaceholder: { height: 120, background: '#f0f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  cardBody: { padding: 16 },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 },
  categoryBadge: { fontSize: 12, background: '#EEF2FF', color: '#4C6FFF', borderRadius: 6, padding: '3px 8px', fontWeight: '700' },
  freeBadge:  { fontSize: 12, background: '#F0FFF4', color: '#2D6A4F', borderRadius: 6, padding: '3px 8px', fontWeight: '700' },
  priceBadge: { fontSize: 12, background: '#FFF8E1', color: '#b45309', borderRadius: 6, padding: '3px 8px', fontWeight: '700' },
  cardTitle: { margin: '0 0 4px', fontSize: 17, fontWeight: '700', color: '#1D3557' },
  cardCity:  { margin: '0 0 4px', fontSize: 13, color: '#6B7C93' },
  cardHours: { margin: '0 0 8px', fontSize: 12, color: '#888' },
  cardDesc:  { margin: '0 0 12px', fontSize: 13, color: '#555', lineHeight: 1.5 },
  cardActions: { display: 'flex', gap: 8 },

  btnPrimary:   { padding: '9px 18px', background: '#E63946', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: '700', fontSize: 14 },
  btnSecondary: { padding: '9px 18px', background: '#eee', color: '#333', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14 },
  btnSmall:     { padding: '6px 12px', background: '#f0f2f5', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 },

  empty: { gridColumn: '1/-1', textAlign: 'center', padding: '60px 0', color: '#888', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 },
};
